import type { CBrowserPressOnlineTranslations } from "./pl";

/**
 * CBrowserPressOnline - deutsche Uebersetzungen (Online-Presse-Browser -
 * Ausgabenliste + Ausgabenansicht mit Seiten klickbar in eine Lightbox).
 */
export const de: CBrowserPressOnlineTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyList: "Keine Ausgaben zum Anzeigen.",
  emptyIssue: "Diese Ausgabe enthaelt noch keine Seiten.",
  backToList: "<- Zurueck zur Ausgabenliste",
  openPage: "Seite oeffnen",
  download: "Herunterladen",
  offer: "Gesamtes Angebot ansehen",
  newsletter: "Newsletter abonnieren",
  applies: "Gueltig",
  from: "von",
  to: "bis",
  /** `pagesCount(5)` -> "5 Seiten". */
  pagesCount: (n: number): string => `${n} ${n === 1 ? "Seite" : "Seiten"}`,
  /** `pageLabel(3)` -> "Seite 3". */
  pageLabel: (n: number) => `Seite ${n}`,
  formatDate: (iso: string): string => {
    const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return iso;
    return `${m[3]}.${m[2]}.${m[1]}`;
  },
};
